import React from "react";
import {BreadCrumbItem} from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import FormSection from "./FormSection";

const breadCrumbs: BreadCrumbItem[] = [
    {
        path: "/",
        label: "Inicio"
    },
    {
        path: "/servicios",
        label: "Servicios",
    },
    {
        path: "/servicios/transporte",
        label: "Transporte",
    },
    {
        path: "/crear",
        label: "Crear",
        isActive: true
    }
]

function CrearServicioTransporte(){
    return (
        <Page title="Registro de Servicio" description="Creación de servicio de transporte." breadCrumbs={breadCrumbs}>
            <FormSection />
        </Page>
    );
}

export default CrearServicioTransporte;